export default {
  // ============================= Set_User_Dataa
  set_userId(state, payload) {
    localStorage.setItem("myTeam_Dash_User_Id", payload);
    state.user.id = payload;
  },
  set_token(state, payload) {
    localStorage.setItem("myTeam_Dash_Token", payload);
    state.user.token = payload;
  },
  set_userName(state, payload) {
    localStorage.setItem("myTeam_Dash_User_name", payload);
    state.user.name = payload;
  },
  set_usertype(state, payload) {
    localStorage.setItem("myTeam_Dash_User_Type", payload);
    state.user.usertype = payload;
  },
  set_userImage(state, payload) {
    localStorage.setItem("myTeam_Dash_userImg", payload);
    state.user.image = payload;
  },
  set_userPhone(state, payload) {
    localStorage.setItem("myTeam_Dash_userPhone", payload);
    state.user.phone = payload;
  },
  set_userCountry(state, payload) {
    console.log("Setting user country in localStorage:", payload);
    localStorage.setItem("myTeam_Dash_user_country", payload);
    state.user.country = payload;
  },
  myTeam_dash_permissions(state, payload) {
    localStorage.setItem("myTeam_dash_permissions", payload);
    state.user.permissions = payload;
  },
  // ============================= Remove_User_Dataa
  remove_user_data(state) {
    console.log("Removing user data from localStorage");
    localStorage.removeItem("myTeam_Dash_User_Id");
    localStorage.removeItem("myTeam_Dash_Token");
    localStorage.removeItem("myTeam_Dash_User_Type");
    localStorage.removeItem("myTeam_Dash_userImg");
    localStorage.removeItem("myTeam_Dash_userPhone");
    localStorage.removeItem("myTeam_dash_permissions");
    localStorage.removeItem("myTeam_Dash_user_country");

    state.user.id = null;
    state.user.token = null;
    state.user.image = null;
    state.user.usertype = null;
    state.user.phone = null;
  },
};
